import classes from "./index.module.css";
import { InfoSecondary } from "../Icons";

interface Props {
  size?: number;
}

export const InfoIcon = ({ size = 20 }: Props) => <InfoSecondary width={size} height={size} className={classes.icon} />;
